import { Mark, mergeAttributes } from "@tiptap/core";

/**
 * Souligné — balise `<u>` uniquement (aligné allowlist CMS).
 */
export const Underline = Mark.create({
  name: "underline",
  parseHTML() {
    return [{ tag: "u" }];
  },
  renderHTML({ HTMLAttributes }) {
    return ["u", mergeAttributes(HTMLAttributes), 0];
  },
  addCommands() {
    return {
      toggleUnderline:
        () =>
        ({ commands }: { commands: { toggleMark: (name: string) => boolean } }) =>
          commands.toggleMark(this.name),
    } as Record<string, unknown>;
  },
});

export default Underline;
